export default __webpack_public_path__ + "static/media/link4.70ef77b7.png";